module.exports = __webpack_public_path__ + "img/interaction.11c5c0ba.jpg";